import React, { Component } from "react";
import { Link, withRouter } from 'react-router-dom';
import { FiX , FiMenu, FiGlobe } from "react-icons/fi";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { LanguageContext } from '../../context/LanguageContext';
import translations from '../../translations';


class Header extends Component{
    static contextType = LanguageContext;

    constructor(props) {
        super(props);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.isActive = this.isActive.bind(this);
       //  this.subMetuTrigger = this.subMetuTrigger.bind(this);
        window.addEventListener('load', function() {
            console.log('All assets are loaded')
        })
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        const headerWrapper = document.querySelector('.header-wrapper');
        const mainmenunav = document.querySelector('.mainmenunav');

        if (headerWrapper && headerWrapper.classList.contains('menu-open')) {
            if (mainmenunav && !mainmenunav.contains(event.target) && !event.target.closest('.humberger-menu')) {
                this.CLoseMenuTrigger();
            }
        }
    }

    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open')
    }

    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open');
    }

    isActive(path) {
        const currentPath = this.props.location.pathname;
        if (path === '/' && currentPath === '/') {
            return true;
        }
        if (path !== '/' && currentPath.startsWith(path)) {
            return true;
        }
        return false;
    }


    render(){
        var elements = document.querySelectorAll('.has-droupdown > a');
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                elements[i].onclick = function() {
                    this.parentElement.querySelector('.submenu').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }
        const { logo, color='default-color' } = this.props;
        let logoUrl;
        if(logo === 'light'){
            logoUrl = <img src="/assets/images/logo/logo-light.png" alt="Digital Agency" />;
        }else if(logo === 'dark'){
            logoUrl = <img src="/assets/images/logo/logo-dark.png" alt="Digital Agency" />;
        }else if(logo === 'symbol-dark'){
            logoUrl = <img src="/assets/images/logo/logo-symbol-dark.png" alt="Digital Agency" />;
        }else if(logo === 'symbol-light'){
            logoUrl = <img src="/assets/images/logo/logo-symbol-light.png" alt="Digital Agency" />;
        }else{
            logoUrl = <img src="/assets/images/logo/logo.png" alt="Digital Agency" />;
        }

        
        return(
            <header className={`header-area formobile-menu header--transparent ${color}`}>
                <div className="header-wrapper" id="header-wrapper">
                    <div className="header-left">
                        <div className="logo">
                            <a href="/">
                                {logoUrl}
                            </a>
                        </div>
                    </div>
                    <div className="header-right">
                        {/* Mobile Side Navigation */}
                        <nav className="mainmenunav d-lg-block">
                            {/* Mobile Nav Header */}
                            <div className="mobile-nav-header d-lg-none">
                                <div className="mobile-nav-logo">
                                    <a href="/">
                                        <img src="/assets/images/logo/logo-light.png" alt="Mass.Dev" />
                                    </a>
                                </div>
                            </div>

                            {/* Navigation Links */}
                            <ul className="mainmenu">
                                <li className={this.isActive('/') ? 'active' : ''}><Link to="/" onClick={this.CLoseMenuTrigger}>{translations[this.context.language].nav.home}</Link></li>
                                <li className={this.isActive('/creative-agency') ? 'active' : ''}><Link to="/creative-agency" onClick={this.CLoseMenuTrigger}>{translations[this.context.language].nav.explore}</Link></li>
                                <li className={this.isActive('/explore') ? 'active' : ''}><Link to="/explore" onClick={this.CLoseMenuTrigger}>{translations[this.context.language].nav.projects}</Link></li>
                                <li className={this.isActive('/service') ? 'active' : ''}><Link to="/service" onClick={this.CLoseMenuTrigger}>{translations[this.context.language].nav.services}</Link></li>
                                <li className={this.isActive('/about') ? 'active' : ''}><Link to="/about" onClick={this.CLoseMenuTrigger}>{translations[this.context.language].nav.about}</Link></li>
                                {/* <li className={this.isActive('/portfolio') ? 'active' : ''}><Link to="/portfolio" onClick={this.CLoseMenuTrigger}>{translations[this.context.language].nav.portfolio}</Link></li> */}
                                <li className={this.isActive('/contact') ? 'active' : ''}><Link to="/contact" onClick={this.CLoseMenuTrigger}>{translations[this.context.language].nav.contact}</Link></li>
                            </ul>

                            {/* Mobile Language Toggle */}
                            <div className="mobile-nav-language d-lg-none">
                                <button
                                    className="language-toggle-btn"
                                    onClick={this.context.toggleLanguage}
                                    aria-label="Toggle Language"
                                >
                                    <FiGlobe />
                                    <span>{this.context.language === 'en' ? 'العربية' : 'English'}</span>
                                </button>
                            </div>

                            {/* Mobile Nav Footer */}
                            <div className="mobile-nav-footer d-lg-none">
                                <div className="mobile-nav-info">
                                    <p>{translations[this.context.language].footer.heading}</p>
                                </div>
                                <div className="mobile-nav-social">
                                    <a href="https://www.facebook.com/massDevelop" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                        <FaFacebookF />
                                    </a>
                                    <a href="https://www.linkedin.com/company/mass-dev/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                        <FaLinkedinIn />
                                    </a>
                                    <a href="https://www.instagram.com/mass.develop/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                        <FaInstagram />
                                    </a>
                                </div>
                            </div>
                        </nav>
                        <div className="header-btn">
                            <button
                                className={`rn-btn language-toggle ${this.context.language === 'ar' ? 'arabic-mode' : 'english-mode'}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.context.toggleLanguage();
                                }}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="lang-icon">
                                    <FiGlobe />
                                </div>
                                <span className={this.context.language === 'ar' ? 'arabic-text-toggle' : ''}>
                                    {translations[this.context.language].nav.languageSwitch}
                                </span>
                            </button>
                        </div>
                        {/* Mobile Language Toggle */}
                        <div className="mobile-language-toggle d-block d-lg-none">
                            <button
                                className="mobile-lang-btn"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.context.toggleLanguage();
                                }}
                                aria-label="Switch Language"
                            >
                                <FiGlobe />
                            </button>
                        </div>
                        {/* Start Humberger Menu  */}
                        <div className="humberger-menu d-block d-lg-none pl--20">
                            <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                        </div>
                        {/* End Humberger Menu  */}
                        <div className="close-menu d-block d-lg-none">
                            <span onClick={this.CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
export default withRouter(Header);